module.exports = __webpack_public_path__ + "img/uz.7c1bc5a1.svg";